import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  isAutoFilled?: boolean;
  hasError?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, value, required, isAutoFilled, hasError, ...props }, ref) => {
    const isEmpty = value === undefined || value === null || value === '';
    const shouldShowError = hasError;
    const shouldShowAutoFilledBg = isAutoFilled && !isEmpty && !hasError;
    const shouldShowRequiredBg = required && isEmpty && !hasError;

    return (
      <input
        type={type}
        value={value}
        required={required}
        className={cn(
          "flex h-10 w-full rounded-md border border-input px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-colors",
          shouldShowError
            ? "bg-red-50/60 dark:bg-red-950/40 border-destructive border-2"
            : shouldShowAutoFilledBg 
              ? "bg-green-50/70 dark:bg-green-950/40 border-green-400/70 dark:border-green-600/70 border-2" 
              : shouldShowRequiredBg 
                ? "bg-red-50/60 dark:bg-red-950/40 border-red-300/60 dark:border-red-600/60 border-2" 
                : "bg-background",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }